import type {ExtendedDocument, Field} from 'typings/portaro.be.types';

// TODO: Remove this and think about better solution

/**
 * Function adds two methods to given document.
 * - getFields
 * - getSubfields
 *
 * @param {ExtendedDocument} d Document, which will be "extended" of new methods.
 */
export function extendDocument(d: ExtendedDocument): ExtendedDocument {

    /**
     * Method extracts fields described by numbers in input argument from document.
     * If no field is specified, it returns all fields.
     * If document doesn't contain any field, it returns [] - empty array
     *
     * @param {number | number[]=} fieldNumbers Number of fields which should be extracted
     * @returns {Field[]} Extracted fields
     */
    d.getFields = function getFields(this: ExtendedDocument, fieldNumbers?: string | string[]): Field[] {
        if (this.fields) {
            if (fieldNumbers) {
                if (!Array.isArray(fieldNumbers)) {
                    fieldNumbers = [fieldNumbers];
                }

                return this.fields.filter((field) => (fieldNumbers as string[]).includes(field.code));
            }

            return this.fields;
        }

        return [];
    };

    /**
     * Method extracts sub-fields described by fields number and sub-fields identification from document
     *
     * @param {number | number[]=} fieldNumbers Field numbers
     * @param {string=} codes Sub-field codes
     * @returns {Field[]} extracted sub-fields
     */
    d.getSubfields = function getSubfields(this: ExtendedDocument, fieldNumbers?: string | string[], codes?: string): Field[] {
        if (this.fields) {
            const fields: Field[] = this.getFields(fieldNumbers);

            return fields
                .flatMap((field) => field.fields)
                .filter((subfield) => subfield && (!(codes) || codes.includes(subfield.code)));
        }

        return [];
    };

    return d;
}
